<template>
    <AppHeader />
  
    <div class="container mx-auto p-4">
      <div class="max-w-7xl mx-auto bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden
                  text-gray-900 dark:text-gray-100">
        <div class="p-4 border-b flex items-center justify-between">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Registros</h2>
          <router-link to="/" class="text-sm text-emerald-700 dark:text-emerald-300 hover:underline">
            Novo registro
          </router-link>
        </div>
  
        <div class="p-4 overflow-x-auto">
          <table class="min-w-full text-sm">
            <thead class="text-left bg-gray-50 dark:bg-slate-700/60 text-gray-700 dark:text-gray-100">
              <tr>
                <th class="px-3 py-2">ID</th>
                <th class="px-3 py-2">Colaborador</th>
                <th class="px-3 py-2">Data de Início</th>
                <th class="px-3 py-2">Data de Término</th>
                <th class="px-3 py-2">Duração</th>
                <th class="px-3 py-2">Processo</th>
                <th class="px-3 py-2">Entrega</th>
                <th class="px-3 py-2">Tarefa</th>
                <th class="px-3 py-2">Itens</th>
                <th class="px-3 py-2">Observações</th>
                <th class="px-3 py-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="a in activities"
                :key="a.id"
                class="border-b dark:border-slate-700 last:border-0 hover:bg-gray-50 dark:hover:bg-slate-700/50"
              >
                <td class="px-3 py-2">{{ a.id }}</td>
                <td class="px-3 py-2">{{ a.collaborator }}</td>
                <td class="px-3 py-2">{{ formatDate(a.start_date) }}</td>
                <td class="px-3 py-2">{{ formatDate(a.current_date) }}</td>
                <td class="px-3 py-2">{{ formatDuration(a.time_duration) }}</td>
                <td class="px-3 py-2">{{ geofLabelMap[a.process] }}</td>
                <td class="px-3 py-2">{{ geofLabelMap[a.dispatch] || a.dispatch}}</td>
                <td class="px-3 py-2">{{ geofLabelMap[a.task] }}</td>
                <td class="px-3 py-2">{{ a.items }}</td>
                <td class="px-3 py-2 max-w-xs">
                  <div class="max-h-20 overflow-y-auto whitespace-pre-wrap break-words text-xs" :title="a.notes">
                    {{ a.notes }}
                  </div>
                </td>
                <td class="px-3 py-2 text-right">
                  <fwb-button gradient="green-blue" outline class="!text-green-600" @click="openEditModal(a)">
                    Editar
                  </fwb-button>
                  <fwb-button gradient="purple-pink" outline class="!text-red-600" @click="confirmDelete(a)">
                    Excluir
                  </fwb-button>
                </td>
              </tr>
  
              <tr v-if="!activities.length">
                <td class="px-3 py-6 text-center text-gray-500 dark:text-gray-400" colspan="7">
                  Nenhum registro ainda.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  
      <div v-if="showModal" class="fixed inset-0 bg-gray-800/60 flex items-center justify-center z-50">
        <div class="bg-white dark:bg-slate-800 p-6 rounded-lg shadow-lg max-w-sm w-full">
          <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">Excluir Registro</h3>
          <p class="text-gray-600 dark:text-gray-300 mb-6">
            Tem certeza que deseja excluir este registro?
          </p>
          <div class="flex justify-end gap-2">
            <button class="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300" @click="showModal = false">
              Cancelar
            </button>
            <button class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700" @click="deleteActivity()">
              Excluir
            </button>
          </div>
        </div>
      </div>
  
      <div class="fixed top-4 right-4 z-50 space-y-2">
        <fwb-toast v-if="toast.delete" type="warning">Registro excluído com sucesso.</fwb-toast>
        <fwb-toast v-if="toast.error" type="danger">{{ toast.errorMessage }}</fwb-toast>
      </div>
    </div>

    <!-- Modal de Edição -->
    <div v-if="showEditModal" class="fixed inset-0 bg-gray-800/60 flex items-center justify-center z-50">
      <div class="bg-white dark:bg-slate-800 p-6 rounded-lg shadow-lg max-w-sm w-full">
        <h3 class="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">Editar Registro</h3>

        <!-- Itens do modal de edição-->
        <label class="block text-sm mb-1 text-gray-700 dark:text-gray-300">Data de Início</label>
        <input v-model="selectedActivity.start_date" 
        type="datetime-local" :max="maxStartDate" :min="minStartDate" 
        class="w-full border rounded px-3 py-2 mb-4 bg-white dark:bg-slate-700 dark:border-slate-600 dark:text-gray-100" />

        <!-- Editável - data de término -->
        <label class="block text-sm mb-1 text-gray-700 dark:text-gray-300">Data de Término</label>
        <input v-model="selectedActivity.current_date" type="datetime-local" 
        :max="maxStartDate" :min="minStartDate"
        class="w-full border rounded px-3 py-2 mb-4 bg-white dark:bg-slate-700 dark:border-slate-600 dark:text-gray-100" />


        <div v-if="selectedActivity.gerencia === 'geof'">
          <label class="block text-sm mb-1 mt-3 text-gray-700 dark:text-gray-300">Entrega</label>
          <SearchSelect
            v-model="selectedActivity.dispatch"
            :options="entregasDoProcessoEdit"
            option-label="label"
            option-value="id"
            placeholder="Selecionar entrega…"
            clearable
          />

          <label class="block text-sm mb-1 text-gray-700 dark:text-gray-300">Processo</label>
          <SearchSelect
            v-model="selectedActivity.process"
            :options="processos_GEOF"
            option-label="label"
            option-value="id"
            placeholder="Selecionar processo…"
            clearable
          />

          <label class="block text-sm mb-1 mt-3 text-gray-700 dark:text-gray-300">Tarefa</label>
          <SearchSelect
            v-model="selectedActivity.task"
            :options="tarefasdaAtividadeEdit"
            option-label="label"
            option-value="id"
            placeholder="Selecionar entrega…"
            clearable
          />
        </div>

        <div v-else>
          <label class="block text-sm mb-1 text-gray-700 dark:text-gray-300">Entrega</label>
          <SearchSelect
            v-model="selectedActivity.dispatch"
            :options="unitActivities"
            option-label="entrega"
            option-value="entrega"
            placeholder="Selecionar entrega..."
            clearable
          />
        </div>
        <label class="block text-sm mb-1 text-gray-700 dark:text-gray-300">Itens</label>
        <input v-model="selectedActivity.items" type="number" min="0" class="w-full border rounded px-3 py-2 mb-4 bg-white dark:bg-slate-700 dark:border-slate-600 dark:text-gray-100" />

        <label class="block text-sm mb-1 text-gray-700 dark:text-gray-300">Observações</label>
        <input v-model="selectedActivity.notes" class="w-full border rounded px-3 py-2 mb-4 bg-white dark:bg-slate-700 dark:border-slate-600" />


        <div class="flex justify-end gap-2">
          <button class="px-4 py-2 bg-gray-200 dark:bg-slate-600 dark:text-gray-100 rounded-lg" @click="showEditModal = false">
            Cancelar
          </button>
          <button class="px-4 py-2 bg-emerald-600 text-white rounded-lg"
            @click="updateActivity(selectedActivity.id, selectedActivity); showEditModal = false">
            Salvar
          </button>
        </div>
      </div>
    </div>
  
    <div class="flex justify-center mt-8">
      <AppFooter />
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { FwbButton, FwbToast } from "flowbite-vue";
  import AppHeader from "./Header.vue";
  import SearchSelect from "./SearchSelect.vue";
  import { hierarquia_GEOF, processos_GEOF } from "./GEOF";
 
 
  export default {
    name: "ActivityList",
    components: { FwbButton, FwbToast, AppHeader, SearchSelect },
    data() {
      return {
        activities: [],
        showModal: false,
        selectedActivityId: null,
        toast: { delete: false, error: false, errorMessage: "" },
        apiBase: "/api",
        hierarquia_GEOF,
        processos_GEOF, 
        showEditModal: false,
        selectedActivity: null,
        originalActivity: null,
        unitActivities: [],
        minStartDate: '',
        maxStartDate: '',
        num_max_days: 3
      };
    },
    computed: {
      geofLabelMap() {
      const map = {}

      this.hierarquia_GEOF.forEach(proc => {

        // processo
        map[proc.id] = proc.label

        // entregas
        proc.entrega?.forEach(a => {
          map[a.id] = a.label
        })

        // tarefas
        proc.tarefa?.forEach(e => {
          map[e.id] = e.label
        })

      })

      return map
    },
      entregasDoProcessoEdit() {
        if (!this.selectedActivity?.process) return [];
        const proc = this.hierarquia_GEOF.find(p => p.id === this.selectedActivity.process);
        return proc?.entrega || [];
      },

      tarefasdaAtividadeEdit() {
        if (!this.selectedActivity?.process) return [];
        const proc = this.hierarquia_GEOF.find(p => p.id === this.selectedActivity.process);
        return proc?.tarefa || [];
      },
  },
    watch: {
      'selectedActivity.process'() {
        if (this.selectedActivity) {
          this.selectedActivity.dispatch = null;
          this.selectedActivity.task = null;
        }
    }
    },
    async created() {
      await this.LoadMaxDays();
      this.fetchActivities();
      this.loadUnitActivities();
    },
    methods: {
      async LoadMaxDays() {
        const { data } = await axios.get(`${this.apiBase}/activities/num-days`)
        this.num_max_days = data.num_max_days
      },
      async fetchActivities() {
        try {
          const { data } = await axios.get(`${this.apiBase}/activities`);
          this.activities = data;
        } catch (e) {
          console.error(e);
          this.error("Erro ao buscar registros.");
        }
      },
      confirmDelete(a) {
        this.selectedActivityId = a.id;
        this.showModal = true;
      },
      async deleteActivity() {
        try {
          await axios.delete(`${this.apiBase}/activities/${this.selectedActivityId}`);
          this.activities = this.activities.filter((a) => a.id !== this.selectedActivityId);
          this.showModal = false;
          this.selectedActivityId = null;
          this.toast.delete = true;
          setTimeout(() => (this.toast.delete = false), 2500);
        } catch (e) {
          console.error(e);
          this.error("Erro ao excluir o registro.");
        }
      },
      async updateActivity (id, updatedData) {
        try {
          const { data } = await axios.patch(`${this.apiBase}/activities/${id}`, updatedData);
          const index = this.activities.findIndex(a => a.id === id);
          if (index !== -1) this.activities[index] = data;
        } catch (e) {
          console.error(e);
          this.error(e?.response?.data?.error || "Erro ao atualizar registro");
        }
      },
      async loadUnitActivities() {
        try {
          const { data } = await axios.get(`${this.apiBase}/unit-activities`, {headers: { Authorization: `Bearer ${localStorage.getItem("token")}`}});
          this.unitActivities = Array.isArray(data) ? data: [];
        }
        catch(e) {
          console.error(e);
        }
      },
      formatDuration(totalMinutes) {
        const h = Math.floor(totalMinutes / 60);
        const m = totalMinutes % 60;
        return `${h}h ${m}m`;
      },
       formatDate(isoString) {
        if (!isoString) return ''
        const parts = isoString.split('T')
        const date = parts[0].replace(/-/g, '/')
        if (parts.length < 2) return date
        const [h, m] = parts[1].split(':')
        return `${date} - ${h}:${m}`
      },

      error(msg) {
        this.toast.errorMessage = msg;
        this.toast.error = true;
        setTimeout(() => (this.toast.error = false), 2800);
      },
      openEditModal(a) {
        this.selectedActivity = {...a};
        this.originalActivity = {...a};
        this.showEditModal = true;
        
        const pad = (n) => String(n).padStart(2, "0");
        const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
        const min = new Date(this.originalActivity.start_date);
        const max = new Date(this.originalActivity.current_date);
        max.setDate(max.getDate());
        min.setDate(min.getDate() - this.num_max_days);
        min.setHours(0,0,0,0)
        this.minStartDate = fmt(min);
        this.maxStartDate = fmt(max);
      },
    },
  };
  </script>
  